'use strict';

import {PropertyValueType} from '~/shared/src/mm/PropertySet';

export const getDefaultValueForType = ( type : PropertyValueType ) : AttributeValue => {
    let retVal;

    switch ( type ) {
        case 'BOOLEAN':
            retVal = true;
            break;

        case 'DATE':
        case 'TIME':
        case 'TIMESTAMP':
            retVal = new Date();
            break;

        case 'DOUBLE':
        case 'INTEGER':
            retVal = 1;
            break;

        case 'JSON':
            retVal = '{ "value": "1" }';
            break;

        case 'IMAGEDATA':
            retVal = 'data:image/png;base64,';
            break;
        case 'TIMERULE':
            retVal = 'DTSTART:';
            break;

        case 'STRING':
        case 'TEXT':
        default:
            retVal = 'value';
            break;
    }

    return retVal;
}
